import { Component, Prop, Vue } from 'vue-property-decorator';
import EventBus from '@vertical-plus/vue-js-core/dist/util/event/event-bus';
import Job from '@/model/entity/job/job';
import JobService from '@/model/service/job/job-service';

@Component
export default class JobCard extends Vue
{
    @Prop()
    private value!: Job;

    @Prop()
    private calendarJobId!: number;

    @Prop({
        type: Boolean,
        default: false,
    })
    private faded!: boolean;

    @Prop({
        type: Boolean,
        default: false,
    })
    private fadeUnassigned!: boolean;

    @Prop()
    private fadeUnassignedUserId!: string;

    @Prop({
        type: Boolean,
        default: false,
    })
    private fadeClient!: boolean;

    private get isFaded(): boolean
    {
        if (this.faded)
        {
            return true;
        }

        if (this.fadeUnassigned && ((this.fadeUnassignedUserId && this.value.assigneeId !== this.fadeUnassignedUserId) || (!this.fadeUnassignedUserId && this.value.assigneeId !== this.$user?.id)))
        {
            return true;
        }

        const isUnavailable = !!(this.value.stage?.type === 'closed' || [ JobService.STAGE_WAITING_FOR_CLIENT, JobService.STAGE_ACCEPTANCE_TESTING ].includes(this.value.stage?.id ?? -1));
        if (this.fadeClient && isUnavailable)
        {
            return true;
        }

        return false;
    }

    /**
     * Handles left click
     *
     * @param event
     */

    private onClick(event: Event)
    {
        EventBus.instance.$emit('preview-job', this.value.id);
    }

    /**
     * Handles ctrl clicks
     *
     * @param event
     */

    private onCtrlClick(event: Event)
    {
        EventBus.instance.$emit(
            'open-job', this.value.id, true,
        );
    }

    /**
     * Handles shift clicks
     *
     * @param event
     */

    private onShiftClick(event: Event)
    {
        this.$emit(
            'shift-click', this.value, event,
        );
    }

    /**
     * Handles ctrl + shift clicks
     *
     * @param event
     */

    private onCtrlShiftClick(event: Event)
    {
        this.$emit(
            'ctrl-shift-click', this.value, event,
        );
    }

    /**
     * Handles parent job clicks.
     *
     * @param event
     */

    private onParentJobClick(event: Event)
    {
        EventBus.instance.$emit('preview-job', this.value.parentJobId);
    }

    /**
     * Handles parent job clicks.
     *
     * @param event
     */

    private onParentJobCtrlClick(event: Event)
    {
        EventBus.instance.$emit(
            'open-job', this.value.parentJobId, true,
        );
    }
}